import styled from 'styled-components';
import { Button } from '@material-ui/core';

const ButtonTour = styled(Button)`
  padding: 2px 5px;
`;

export default ButtonTour;
